(function($) {

    function init_slick () {
        $('.st4-case-study-list .slider').each(function(){
            const num_slides = $( '.custom_fancybox', this ).length;
            $(this).slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: num_slides > 4,
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: inline-block;"><span class="far fa-arrow-right "></span><span class="sr-only">Next</span></button>',
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: inline-block;"><span class="far fa-arrow-left"></span><span class="sr-only">Previous</span></button>',
                responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 3,
                        arrows: num_slides > 3,
                      }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                          slidesToShow: 1,
                          arrows: num_slides > 1,
                        }
                      },
                  ]
            })
        });
    }

    $( document ).on( 'facetwp-loaded', init_slick );
  
  })(jQuery);